import React, {
  createContext,
  Dispatch,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { Reducer } from "./reducer";
import LogsModal from "../components/LogsModal/LogsModal";
import SnackBar from "../components/SnackBar/SnackBar";
import { Action, Store } from "../decleration";
import { useRouter } from "next/router";
import { handleSystemStatus } from "@/backend/projects";
export const initialState: Store = {
  user: {
    id: "",
    jwt: "",
    email: "",
    username: "",
    company: "",
    first_name: "",
    last_name: "",
    is_authenticated: false,
  },
  theme: "light",
  team: {
    isMember: false,
  },
  log: {
    id: "",
    type: "history", //deploy, history, redeploy
    projectId: "",
    title: "",
    hasLogs: false,
  },
  snackbar: {
    open: false,
    message: "",
    content: null,
  },
};
const AppStatusContext = createContext({
  appStatus: "UP",
  handleAppStatus: () => {},
});

export const AppStatusProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [appStatus, setAppStatus] = useState<string>("UP");

  const handleAppStatus = useCallback(async () => {
    const response = await handleSystemStatus();
    const status = response.data.find(
      (val: any) => val.name === "Brimble",
    ).status;
    setAppStatus(status);
  }, []);

  useEffect(() => {
    handleAppStatus();
  }, []);

  return (
    <AppStatusContext.Provider value={{ appStatus, handleAppStatus }}>
      {children}
    </AppStatusContext.Provider>
  );
};

export const GlobalContext = createContext<{
  state: Store;
  dispatch: Dispatch<Action>;
}>({ state: initialState, dispatch: () => null });
export const ContextProvider = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const isAuthRoute =
    router.pathname.startsWith("/login") ||
    router.pathname.startsWith("/register");
  const [state, dispatch] = useReducer(Reducer, initialState);

  return (
    <GlobalContext.Provider value={{ state, dispatch }}>
      <SnackBar {...state.snackbar} dispatch={dispatch} />
      <AppStatusProvider>
        {children}
        {!isAuthRoute && <LogsModal />}
      </AppStatusProvider>
    </GlobalContext.Provider>
  );
};

export const useStoreContext: () => {
  state: Store;
  dispatch: (action: Action) => void;
} = () => {
  const { state, dispatch } = useContext(GlobalContext);
  return { state, dispatch };
};

export const useAppStatus = () => {
  return useContext(AppStatusContext);
};
